import React, { useLayoutEffect } from 'react';
import { getCookie, setCookie } from '~/utils/cookie-handler';
import {
  checkIfFromEurope,
  getCompleteStyleManualPositioning,
} from '~/utils/helpers';
import TextComponent from '../reusable/TextComponent';
import PostHogHelper from '~/utils/posthog-helper';

const cookieKey = 'bn_privacy_eur';

const PrivacyBanner: React.FC<{ data: PrivacyBanner }> = ({ data }) => {
  const [shouldDisplayBanner, setShouldDisplayBanner] = React.useState(false);
  useLayoutEffect(() => {
    const cookieValue = getCookie(cookieKey);
    if (!cookieValue) {
      if (checkIfFromEurope()) {
        setShouldDisplayBanner(true);
      }
    }
  }, []);
  let { desktop } = getCompleteStyleManualPositioning({
    mobile: undefined,
    desktop: data.image_field,
  });

  if (!shouldDisplayBanner) {
    return null;
  }

  function handleClick(buttonNumber: number) {
    setCookie(cookieKey, '1', 30);
    PostHogHelper.capture('EUR Privacy Banner Clicked', {
      button: buttonNumber,
    });
    setShouldDisplayBanner(false);
  }

  return (
    <div
      className='privacy-banner-wr slide-in relative'
      style={{
        background: data.container_background,
        borderRadius: (data.border_radius || 0) + 'rem',
        paddingLeft: (data.container_padding?.left || 0) + 'rem',
        paddingRight: (data.container_padding?.right || 0) + 'rem',
      }}
    >
      <img
        src={data.image_field.src}
        alt={data.image_field.alt}
        title={data.image_field.alt}
        style={{
          ...desktop,
        }}
        className='w-full'
      />
      {data.text_content?.map((textData, index) => {
        return (
          <TextComponent
            key={index}
            data={textData}
          />
        );
      })}
      <div className='mt-7 flex justify-between gap-6 text-[1rem] font-[500]'>
        <button
          className='w-full rounded-[3px] px-4 py-3 transition-all duration-100 hover:scale-105'
          style={{
            backgroundColor: data.container_front_color,
            color: data.container_background,
          }}
          onClick={() => handleClick(1)}
        >
          {data.cta_1_text}
        </button>
        <button
          className='w-full rounded-[3px] px-4 py-3 transition-all duration-100 hover:scale-105'
          style={{
            backgroundColor: data.container_background,
            color: data.container_front_color,
            outline: '1px solid ' + data.container_front_color,
          }}
          onClick={() => handleClick(2)}
        >
          {data.cta_2_text}
        </button>
      </div>
    </div>
  );
};

export default PrivacyBanner;
